export default __webpack_public_path__ + "static/media/pixellab--graphic-design--02--600x450.1ae774e2.jpg";